import React from 'react';
import { formatDuration } from '../../utils/formatDuration';
import DocumentList from './DocumentList';
import StatusSelect from '../StatusSelect';

const ordinalSuffix = (d) => {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};

const AppointmentRow = ({ appointment, documents, onViewInvoice, onStatusChange }) => {
  const date = new Date(appointment.scheduled_date);
  const day = date.getDate();
  const formattedDate = `${day}${ordinalSuffix(day)} ${date.toLocaleDateString('en-GB', { month: 'short' })}`;
  const formattedTime = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  const duration = appointment.estimated_duration ? formatDuration(appointment.estimated_duration) : null;

  // Filter documents for this specific appointment
  const aptInvoices = (documents?.invoices || []).filter(i => i.appointment_id === appointment.id);
  const aptReports = (documents?.treatmentReports || []).filter(r => r.appointment_id === appointment.id);
  const aptEstimates = (documents?.estimates || []).filter(e => e.appointment_id === appointment.id);
  const aptGuarantees = (documents?.guarantees || []).filter(g => g.appointment_id === appointment.id);

  const formatType = (type) => type ? type.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : null;

  return (
    <div className="py-2.5 border-b border-gray-100 last:border-b-0">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-sm flex-wrap">
          <span className="font-medium text-gray-900">{formattedDate}</span>
          <span className="text-gray-400">&middot;</span>
          <span className="text-gray-600">{formattedTime}</span>
          {duration && (
            <>
              <span className="text-gray-400">&middot;</span>
              <span className="text-gray-500">{duration}</span>
            </>
          )}
          <StatusSelect
            value={appointment.status || 'scheduled'}
            onChange={(val) => onStatusChange && onStatusChange(appointment, val)}
            options={[
              { value: 'scheduled', label: 'Scheduled' },
              { value: 'confirmed', label: 'Confirmed' },
              { value: 'in_progress', label: 'In Progress' },
              { value: 'completed', label: 'Completed' },
              { value: 'cancelled', label: 'Cancelled' },
              { value: 'rescheduled', label: 'Rescheduled' },
            ]}
          />
          {appointment.appointment_type && (
            <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-indigo-50 text-indigo-700">
              {formatType(appointment.appointment_type)}
            </span>
          )}
        </div>

      </div>

      {/* Pre-visit notes */}
      {appointment.notes && (
        <p className="text-xs text-gray-500 italic mt-1 ml-0.5">{appointment.notes}</p>
      )}

      {/* Documents linked to this appointment */}
      <DocumentList
        invoices={aptInvoices}
        treatmentReports={aptReports}
        estimates={aptEstimates}
        guarantees={aptGuarantees}
        onViewInvoice={onViewInvoice}
      />
    </div>
  );
};

export default AppointmentRow;
